import { US_STATES } from 'shared';
import { Field } from '@/components/field.js';
import { Select } from '@/components/select.js';
import type { AddressFieldErrors, AddressFormState } from '@/lib/customer-form.js';

interface AddressFieldsProps {
  values: AddressFormState;
  errors: AddressFieldErrors;
  onChange: (key: keyof AddressFormState, value: string) => void;
  /** Ids must be unique inside the shadow root; each screen namespaces its own instance. */
  idPrefix: string;
  /** Rendered on every field — all four are required. */
  labelAux?: string;
}

/** One block for both screens, so the address a customer was rated on and the one printed on
 *  their contract cannot drift apart. */
export function AddressFields({
  values,
  errors,
  onChange,
  idPrefix,
  labelAux,
}: AddressFieldsProps) {
  return (
    <>
      <Field
        key={`${idPrefix}-street1`}
        id={`${idPrefix}-street1`}
        label="Street address"
        labelAux={labelAux}
        placeholder="123 Main St"
        autoComplete="address-line1"
        value={values.street1}
        error={errors.street1}
        onInput={(e) => onChange('street1', (e.currentTarget as HTMLInputElement).value)}
      />

      <div className="sm-row-csz" key={`${idPrefix}-csz`}>
        <Field
          id={`${idPrefix}-city`}
          label="City"
          labelAux={labelAux}
          placeholder="Tampa"
          autoComplete="address-level2"
          value={values.city}
          error={errors.city}
          onInput={(e) => onChange('city', (e.currentTarget as HTMLInputElement).value)}
        />
        <Select
          id={`${idPrefix}-state`}
          label="State"
          labelAux={labelAux}
          placeholder="Select"
          options={US_STATES}
          value={values.state}
          error={errors.state}
          onChange={(e) => onChange('state', (e.currentTarget as HTMLSelectElement).value)}
        />
        <Field
          id={`${idPrefix}-postal-code`}
          label="ZIP"
          labelAux={labelAux}
          inputMode="numeric"
          placeholder="33602"
          autoComplete="postal-code"
          maxLength={10}
          value={values.postalCode}
          error={errors.postalCode}
          onInput={(e) => onChange('postalCode', (e.currentTarget as HTMLInputElement).value)}
        />
      </div>
    </>
  );
}
